/**
 *
 * @param {string} year Year
 * @param {string} month Month as 01 to 12
 * @param {Array <string>} yearOptions Array with year options
 * @returns Object containing year and month for the result
 */
export function getPreviousMonth(year, month, yearOptions) {
  const yearInt = parseInt(year);
  const monthInt = parseInt(month);

  const result = {
    year: "",
    month: "",
  };
  if (monthInt === 1) {
    const previousYear = yearInt - 1;

    if (
      parseInt(yearOptions[yearOptions.length - 1].years_code) > previousYear
    ) {
      return null;
    }

    result.year = previousYear.toString();
    result.month = "12";
  } else {
    result.year = year;
    result.month = (monthInt - 1).toString();
  }

  return result;
}
